// client/nodes/hard-break.ts
import { keymap } from "prosemirror-keymap";
import { HARD_BREAK_KEY, HARD_BREAK_SCHEMA } from "../../schema/nodes/hard-break.js";
function insertHardBreak(state, dispatch) {
  if (dispatch) {
    const { schema, selection } = state;
    const { $from } = selection;
    let tr = state.tr.insert($from.pos, schema.nodes[HARD_BREAK_KEY].create());
    dispatch(tr);
  }
  return true;
}
var hardBreak = () => ({
  node: {
    name: HARD_BREAK_KEY,
    schema: HARD_BREAK_SCHEMA()
  },
  menuItems: [
    {
      icon: "insert_page_break",
      shouldVisualize(editorView) {
        return insertHardBreak(editorView.state);
      },
      label: "Zeilenumbruch",
      run(editorView) {
        return insertHardBreak(editorView.state, editorView.dispatch);
      }
    }
  ],
  plugins(schema) {
    return [
      keymap({
        "Shift-Enter": insertHardBreak
      })
    ];
  }
});
export {
  hardBreak
};
